import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import '@/utils/lib-flexible.js'
import 'element-ui/lib/theme-chalk/index.css'; //全局引入element的样式
Vue.config.productionTip = false
import ElementUI from 'element-ui'; //按需引入element-ui的组件
Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$message = Message;
Vue.prototype.$base64Encode = function (str) {
	return btoa(str);
}
new Vue({
	render: h => h(App),
	router: router
}).$mount('#app')